<template>
	<div style="height: 100%;">
		<page class="" v-if="$route.path === '/englishIndex'">
			<english-header :headerActive="true"></english-header>
			<cms-article-list :pid="$cid.english.banner" :limit="4" class="english-banner">
				<template slot-scope="{ list }">
					<el-carousel class="english-banner" :interval='7000'>
						<el-carousel-item v-for="item in list">
							<cms-image :src="item.cover"></cms-image>
						</el-carousel-item>
					</el-carousel>
				</template>
			</cms-article-list>
			<div class="english-flex">
				<div class="english-about english-bottom-line">
					<cms-article-list :pid="$cid.english.about" :limit="1" class="left">
						<template slot-scope="{ list }">
							<div v-for="item in list">
								<p>{{item.title}}</p>
								<div class="content">{{item.intro}}</div>
								<div class="more english-arrow"><a target="_blank" :href="'/new/TravelInfo/AboutUs'">Learn more</a></div>
							</div>
						</template>
					</cms-article-list>
					<div class="right">
						<p>
							Notice
							<span class="english-arrow"><a target="_blank" :href="'/new/TravelInfo/Notice'">More</a></span>
						</p>
						<div class="notice">
							<img src="../img/images_en/home-notice-pic.jpg" alt="">
							<div class="mask">
								<div class="hover">
									<div class="price-item">
										<div class="title">Busy Season</div>
										<div class="info">(From January 16th to December 14th every year)</div>
										<div class="price">Full-price: <span>CNY 160.0</span> Half-price: <span>CNY 80.0</span></div>
									</div>
									<div class="price-item">
										<div class="title">Off-Season</div>
										<div class="info">(From December 15th to January 15th of the following year)</div>
										<div class="price">Full-price: <span>CNY 110.0</span> Half-price: <span>CNY 55.0</span></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="english-culture english-bottom-line">
					<p>Culture</p>
					<cms-column-list :pid="$cid.english.culture.id" :limit="4" class="english-img-list">
						<template slot-scope="{list}">
							<div class="culture-img" :style="{backgroundImage: 'url(' + item.cover + ')', cursor: 'pointer'}"
								v-for="item in list" @click="$openNewWindow(columns[item.id])">
								<div class="mask">{{item.name}}</div>
							</div>
						</template>
					</cms-column-list>
				</div>
				<div class="english-how english-bottom-line">
					<p>How to Play</p>
					<div class="english-img-list">
						<cms-article-list :pid="$cid.english.play" :limit="1">
							<template slot-scope="{ list }">
								<div class="english-how-img" :style="{backgroundImage: 'url(' + item.cover + ')'}"
									v-for="(item, index) in list">
									<div class="mask" style="cursor: pointer;" @click="$openNewWindow('/new/PlayStay/HowToPlay/HowToPlayDetail?id=' + item.id)">
										<div class="title">{{item.title}}</div>
										<div class="detail">{{item.intro}}</div>
									</div>
								</div>
							</template>
						</cms-article-list>
						<cms-article-list :pid="$cid.english.play" :limit="3" class="how-article-list">
							<template slot-scope="{ list }">
								<div class="how-article-item" v-for="(item, index) in list" v-if="index > 0">
									<div class="how-article-img">
										<cms-image :src="item.cover" alt=""></cms-image>
									</div>
									<div class="hotel-title" style="cursor: pointer;" @click="$openNewWindow('/new/PlayStay/HowToPlay/HowToPlayDetail?id=' + item.id)">{{item.title}}</div>
									<div class="hotel-name">{{item.intro}}</div>
								</div>
							</template>
						</cms-article-list>
					</div>
				</div>
				<div class="english-hotel">
					<div class="hotel">
						<p>Hotel
							<span class="english-arrow"><a target="_blank" :href="'/new/PlayStay/Hotel'">More</a></span>
						</p>
						<cms-article-list :pid="$cid.english.hotel" :limit="2" class="english-img-list">
							<template slot-scope="{ list }">
								<div class="english-img-item" v-for="item in list" style="cursor: pointer;" @click="$openNewWindow('/new/PlayStay/Hotel/HotelDetail?id=' + item.id)">
									<img :src="item.cover" class="img-top" alt="">
									<div class="hotel-name home">{{item.title}}</div>
								</div>
							</template>
						</cms-article-list>
					</div>
					<div class="gift">
						<p>Gift
							<span class="english-arrow"><a target="_blank" :href="'/new/PlayStay/Gift'">More</a></span>
						</p>
						<cms-article-list :pid="$cid.english.gift" :limit="2" class="english-img-list">
							<template slot-scope="{ list }">
								<div class="english-img-item" v-for="item in list" style="cursor: pointer;" @click="$openNewWindow('/new/PlayStay/Gift/GiftDetail?id=' + item.id)">
									<img :src="item.cover" class="img-top" alt="">
									<div class="hotel-name home">{{item.title}}</div>
								</div>
							</template>
						</cms-article-list>
					</div>
				</div>
			</div>
			<english-footer />
		</page>
		<router-view v-else></router-view>
	</div>
</template>

<script>
	import '../less/english/mobileEn.css'
	import '../less/english/index.css'
	export default {
		data() {
			return {
				columns: {
					'1745247030871150594': '/new/Culture/Buddhist',
					'1745247243513974785': '/new/Culture/Martial',
					'1745247354512035842': '/new/Culture/Tea',
					'1745247465900167169': '/new/Culture/Food',
				}
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/english/index.vue